import { Address } from '@melio/platform-api';

export const enum SummaryTypeEnum {
  OPEN_BALANCE = 'openBalance',
  SCHEDULED = 'scheduled',
  PAID = 'paid',
}

export const enum DeliveryMethodIconsEnum {
  BANK = 'bank-out',
  PAPER_CHECK = 'paper-check',
  RPPS = 'directory-payment',
  VIRTUAL_CARD = 'mastercard',
  INTERNATIONAL = 'international',
}

export const enum DataComponentEnum {
  VENDORS_PAGE = 'vendors-page',
  VENDORS_LIST = 'vendors-list',
  CARD_LIST = 'card-list',
  SORTED_CARD_LIST = 'sorted-card-list',
  SINGLE_VENDOR_PAGE = 'single-vendor-page',
  PAYMENT_SUMMARY = 'payment-summary',
  PAYMENT_OVERVIEW = 'payment-overview',
  RECURRING_PAYMENTS = 'recurring-payments',
  RECURRING_PAYMENT = 'recurring-payment',
  NEW_VENDOR_PAGE = 'new-vendor',
  DELIVERY_METHODS = 'delivery-methods',
  VENDOR_DETAILS = 'vendor-details',
  VENDOR_DETAILS_FORM = 'vendor-details-form',
}

export type VendorDetailsFormFields = {
  companyName: string;
  nickname?: string | null;
  accountNumber?: string | null;
  address?: Address | null;
  fullName?: string | null;
  email?: string | null;
  phone?: string | null;
};

export interface VendorBillsTableBill {
  id: number;
  date: string;
  invoiceId: string;
  amount: string;
  category?: string;
}

export interface VendorBillsTableProps {
  vendor: { name: string; id: number };
  bills: VendorBillsTableBill[];
}
